<script setup lang="ts">
import type { UserDelegation } from "~/modules/relation/delegation/models/UserDelegation.interface";
import type { RelationEntity } from "~/modules/relation/models/RelationEntity.interface";

defineProps<{
  organizationCode?: number;
  businessUnitCode?: number;
  userLogin?: string;
  receivedDelegations?: RelationEntity[] | null;
  userDelegations?: UserDelegation[] | null;
}>();
</script>

<template>
  <div class="flex flex-col gap-2">
    <user-delegation-form
      v-for="delegation in userDelegations"
      :key="delegation.id"
      :organization-code="organizationCode"
      :business-unit-code="businessUnitCode"
      :user-login="userLogin"
      :received-delegations="receivedDelegations"
      :user-delegation="delegation"
    />
  </div>
</template>
